import React from "react";

import { SectionCard, ToggleSwitch } from "shared/ui";

import { ScheduleEditor } from "features/MenuItemEditor/components/ScheduleEditor";
import { useMenuItemEditorContext } from "features/MenuItemEditor/context";

export const ScheduleTab = () => {
    const state = useMenuItemEditorContext();
    const schedule = state.schedule;

    if (!schedule) return null;

    const setEnabled = (isEnabled: boolean) => state.setSchedule({ ...schedule, isEnabled });

    return (
        <SectionCard
            title="Расписание показа позиции"
            description="Вне указанных интервалов позиция не показывается в меню"
            headerRight={
                <ToggleSwitch checked={schedule.isEnabled} onChange={setEnabled} label="Настроить" />
            }
        >
            {schedule.isEnabled && (
                <ScheduleEditor schedule={schedule} onChange={state.setSchedule} />
            )}
        </SectionCard>
    );
};
